import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustStrip } from './components/TrustStrip';
import { EastEndWay } from './components/EastEndWay';
import { Services } from './components/Services';
import { AppointmentRequest } from './components/AppointmentRequest';
import { Reviews } from './components/Reviews';
import { ShopExperience } from './components/ShopExperience';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  return <div className="w-full bg-white font-sans" data-id="element-0" data-mp="2mmlv773am95u">
      <Header data-id="element-1" data-mp="2mjpxnjvcxmhx" />
      <main data-id="element-2" data-mp="31aqfuglwour9">
        <Hero data-id="element-3" data-mp="31agq8u4rwpm3" />
        <TrustStrip data-id="element-4" data-mp="31ayplzmqfjy8" />
        <EastEndWay data-id="element-5" data-mp="31bi8bik7icdb" />
        <Services data-id="element-6" data-mp="31ctdnmtavs6j" />
        <AppointmentRequest data-id="element-7" data-mp="2wk09b01quluz" />
        <Reviews data-id="element-8" data-mp="2wjqgl4pbe0ll" />
        <ShopExperience data-id="element-9" data-mp="2wj8ehrfz0s5r" />
      </main>
      <SiteFooter data-id="element-10" data-mp="2wi5nljineppu" />
    </div>;
}